import React, { useState } from 'react';

import Datepicker from 'components/datepicker'

const MarketChartsDate = () => {
  const [ value, setValue ] = useState(new Date());

  return (
    <Datepicker 
      value={value}
      onChange={date => setValue(date)}
    />
  );
};

export default MarketChartsDate;
